module.exports = __webpack_public_path__ + "ENG_SPT7-Cookie_225002682-79582a53706e141c9892b2e96467fa2f.png";